module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('prénom')
    }
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("En matière de placement, les conseils d'un professionnel sont :")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.ratings,
      "selected": _vm.conseilRate
    },
    on: {
      "change": function($event) {
        _vm.conseilRate = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tCombien d'interlocuteurs vous accompagnent sur vos contrats souscrits ?\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-add-children row"
  }, [_c('div', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        return _vm.setContractCounselor(-1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-form-less"
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        return _vm.setContractCounselor(1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-form-plus"
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-add"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.nbContractCounselor) + "\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tCombien d'interlocuteurs vous accompagnent sur l'ensemble de votre patrimoine ?\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-add-children row"
  }, [_c('div', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        return _vm.setPatrimonialCounselor(-1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-form-less"
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        return _vm.setPatrimonialCounselor(1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-form-plus"
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-add"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.nbPatrimonialCounselor) + "\n\t\t\t")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aae3779"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/MyPatrimonialLandscape/Following.vue
// module id = 1093
// module chunks = 0